import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as actions from "../../redux/actions/index";

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    formField: {
        margin: "5px 5px 5px 0px",
    }
  }));

export default function FilterPanel(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const isCorporate = useSelector((state) => state.user.userData.is_corporate)
    const groupID = useSelector((state) => state.user.userData.group)
    // Local values for filter form
    const [localState, setLocalState] = useState({
        agentName: "",
        listingId: "",
        listingStreet: "",
        group_id: groupID
      })

    // Local function for form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(actions.loadListings(1, isCorporate, localState));
    }
    // Local function for all field changes
    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        setLocalState({
            ...localState,
            [name]: value
        });
      }

    return (
        <div className={classes.root}>
            <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography className={classes.heading}>Filters</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <Box>
                    <TextField
                        id="agent-name"
                        name="agentName"
                        onChange={handleInputChange}
                        className={classes.formField}
                        label="Agent name"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        />
                    <TextField
                        id="listing-id"
                        name="listingId"
                        onChange={handleInputChange}
                        className={classes.formField}
                        label="Listing ID"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        />
                    <TextField
                        id="listing-street"
                        name="listingStreet"
                        onChange={handleInputChange}
                        className={classes.formField}
                        label="Listing street name"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        />
                    </Box>
                    {/* Add sorting by name / id (asc \ desc) */}
                    <Button variant="outlined" color="primary" type="submit">
                        Filter
                    </Button>
                </form>
            </AccordionDetails>
            </Accordion>
        </div>
    );
}